import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import css from './AI.module.scss';
import * as ai from './Slots';
import SlotsList from "./SlotsList";
import { addStrength, colorNameToRgb, foundInArray, toRgb } from './Util';
import { startSynonyms, undoSynonyms } from './Language';
import ListOfWords from './ListOfWords';
import colors from "color-convert";
import tinycolor from "tinycolor2";

export function AI() {
    const [imgSource, setImageSource] = useState('/img/blank.png');
    const [textOut, setTextOut] = useState('');
    const [textStyle, setTextStyle] = useState({});
    const [imageMode, setImageMode] = useState(false);
    const [stack, setStack] = useState([]);
    const [stack2, setStack2] = useState([]);
    const [userInput, setUserInput] = useState('');
    const [randomStyles, setRandomStyles] = useState([]);
    const [showAutoGen, setShowAutoGen] = useState(false);
    const [autoGenNumber, setAutoGenNumber] = useState(false);

    const fonts = ['Lacquer', 'Mansalva', 'Turret Road', 'Potta One', 'Hachi Maru Pop', 'Stick', 'Train One', 'Reggae One', 'DotGothic16', 'Zen Dots', 'Zen Tokyo Zoo', 'Yuji Boku', 'Neonderthaw', 'Moo Lah Lah', 'Mea Culpa', 'Rubik Wet Paint', 'Rubik Puddles', 'Grape Nuts', 'Updock', 'Tapestry', 'Rubik Iso', 'Rubik Maze', 'Rubik Vinyl', 'Rubik Gemstones', 'Rubik Storm', 'Handlee', 'Aldrich', 'Aladin', 'ProstoOne',
        'Black Ops One', 'Leckerli One', 'Rochester', 'Mrs Saint Delafield', 'Mansalva', 'Irish Grover', 'Sofia', 'Grape Nuts', 'Changa One', 'Wallpoet', 'Knewave', 'Rye', 'Macondo', 'Allison', 'Yatra One', 'Amita', 'Norican', 'Freckle Face',
        'Silkscreen', 'Allan', 'Oregano', 'Ranchers', 'Montserrat Subrayada', 'DotGothic16', 'Gugi',];
    const fontMode = window.location.toString().indexOf("font") > 0;
    const showHelp = window.location.toString().indexOf("help") > 0;

    useEffect(() => {
        render();
    }, [stack]);
    // <div><img src="logo.png" alt="DesignPro" /></div>

    return (
        <div className={css.body}>

            <div className="user-select-none">
                <div className={css.titleSection}>
                    <div className={css.title}>Let’s create a sketch!</div>
                    <svg className={css.undoButton} onClick={undo} width="21" height="9" viewBox="0 0 21 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.5 1C7.85 1 5.45 1.99 3.6 3.6L0 0V9H9L5.38 5.38C6.77 4.22 8.54 3.5 10.5 3.5C14.04 3.5 17.05 5.81 18.1 9L20.47 8.22C19.08 4.03 15.15 1 10.5 1Z"
                            fill="black"
                            fillOpacity="0.54"
                            className={css.undoButton}
                        />
                    </svg>

                </div>
            </div>

            <div className={css.previewSection}>
                <div className={css.previewImageSection}>
                    {imageMode && <img className={css.designImage} src={imgSource} alt={imgSource} />}
                    {!imageMode && <div id="textPreview" style={textStyle} className={css.textRender}>{textOut}</div>}
                </div>
                <div className={css.searchSection}>
                    <Input
                        placeholder="What would you like to sketch?"
                        className={css.searchBox}
                        onPressEnter={makeDesign}
                        onChange={(event) => setUserInput(event.target.value)}
                        value={userInput}
                    />
                    <br />
                    {
                        stack2.map(item => <div className={css.listItem} key={item.time}>
                            {item.input}
                        </div>)
                    }
                </div>
            </div>


            {((stack.length > 0) && showAutoGen) && <div>
                <br />
                <div className={css.titleDownloads}>
                    <img
                        src="/icon/refresh.png"
                        alt="Save"
                        className={css.refreshRandomStyles}
                        onClick={() => {
                            refreshRandomStyles(textStyle.color, autoGenNumber);
                        }} />AI Generated Designs</div>

                <div className={css.randomStyles}>
                    {
                        randomStyles.map
                            (style =>
                                <div key={style.id} style={style} className={css.randomStyleItem}>

                                    <div>{textOut}</div>
                                </div>
                            )
                    }

                </div>
            </div>}


            {
                showHelp && <div>
                    <pre>state: {JSON.stringify({
                        imageMode, imgSource, textOut,
                        textStyle, userInput, showAutoGen, autoGenNumber,
                        randomStyles: randomStyles.length,
                        maxLevel: getMaxLevel()
                    }, null, 2)}</pre>
                    <div className={css.slotsList}>
                        <h1 className={css.bigHeading}>Memory Situation</h1>
                        <div>User input: {userInput}</div>
                        <SlotsList slots={stack} mutate={true} setStack={setStack} setStack2={setStack2} makeDesign={makeDesign}></SlotsList>
                    </div>

                    <div className={css.slotsList}>
                        <h1 className={css.bigHeading}>Options Available</h1>
                        <SlotsList slots={ai.slots} mutate={false} setStack={setStack} setStack2={setStack2} makeDesign={makeDesign}></SlotsList>
                    </div>

                    <ListOfWords title="Start words" words={startSynonyms()} />
                    <ListOfWords title="Undo words" words={undoSynonyms()} />

                </div>
            }


        </div>
    );

    function undo() {
        stack.splice(stack.length - 1, 1);
        const newArry = [...stack];
        setStack(newArry);
        const reverseArray = newArry.slice().reverse();
        console.log('left items', reverseArray);
        setStack2([...reverseArray]);
    }

    function restart() {
        setStack([]);
        setStack2([]);
    }

    function processStyleStage() {

    }

    function makeDesign() {
        const input = userInput.trim();
        // start
        if (foundInArray([input], startSynonyms())) {
            restart();
            return;
        }

        //undo 
        if (foundInArray([input], undoSynonyms())) {
            undo();
            return;
        }

        //Process slots
        const inputWords = input.split(' ');
        if (input.length === 0) return;

        // Check entry point if stack is zero 
        if (stack.length === 0) {
            const letters = getLetters(input);
            if (!letters.success) return;
        }

        for (let i = 0; i < ai.slots.length; i++) {
            const { level, resolution, keys, patterns, replace } = ai.slots[i];
            const alreadySelected = stack.filter(item => item.level === level);
            // If stack has level present, it would be skipped 
            // Need to cover it later in replacement model 
            if (alreadySelected.length > 0) {
                // continue;
            }

            const loopSlot = ai.slots[i];
            const find = {
                matchResult: null,
                matchType: ai.patternMatchType.noMatch,
            };
            //Match by regex
            if (find.matchType === ai.patternMatchType.noMatch) {
                for (const [key, pattern] of Object.entries(patterns)) {
                    const matchResult = pattern(input);
                    if (matchResult.success) {
                        //debugger
                        find.matchType = ai.patternMatchType.regex;
                        find.matchResult = matchResult;
                    }
                }
            }

            if (find.matchType === ai.patternMatchType.noMatch) {
                for (let i2 = 0; i2 < keys.length; i2++) {
                    const { key, type, variations, userValue, defaultValue } = keys[i2];
                    const loopKey = keys[i2];

                    //Match by keyword
                    const foundWord = foundInArray(inputWords, variations);
                    if (foundWord) {
                        find.matchType = ai.patternMatchType.keyword;
                        find.matchResult = foundWord;
                    }
                }
            }


            if (find.matchType !== ai.patternMatchType.noMatch) {
                const clone = JSON.parse(JSON.stringify(loopSlot));
                clone.input = userInput.toString();
                clone.find = find;
                const date = new Date();
                const timeTick = date.getTime();
                clone.time = timeTick;
                const newArray = [...stack, clone];
                newArray.sort((a, b) => (a.time > b.time ? 1 : -1));
                setStack(newArray);
                setStack2(newArray.slice().reverse());
                setUserInput('');
                onMatched(loopSlot, clone);
                return;
            }
        }
    }

    function onMatched(slot, clone) {

    }

    function renderReset() {
        setImageMode(false);
        setTextOut('');
        setTextStyle({});
    }

    function renderFontStages() {
        // first and Last slots
        const firstSlot = stack[0];
        const letters = getLetters(firstSlot.input);
        //debugger
        if (!letters.success) return;
        const lastSlot = stack[stack.length - 1];


        // Setup styling by looping over 1.5 slots
        const style = { fontFamily: 'Outfit' };
        let color = 'black';
        for (let indexSlot = 0; indexSlot < stack.length; indexSlot++) {
            const slot = stack[indexSlot];
            if (slot.level === 1.5) {
                let key = slot.find.matchResult.one;
                let value = slot.find.matchResult.two;
                const alts = {
                    "text": "color",
                    "font": "fontFamily",
                    "background": "backgroundColor",
                    "bg": "backgroundColor",
                    "shadow": "textShadow"
                };
                if (alts[key]) {
                    key = alts[key];
                }

                if (key === 'color') {
                    if (value === 'lighter') {
                        color = tinycolor(color).lighten(25).toString();
                    } else
                        if (value === 'darker') {
                            color = tinycolor(color).darken(25).toString();
                        } else {
                            color = value;
                        }
                    value = color;
                }

                style[key] = value;
            }

        }
        //const style = extractStyling(firstSlot.input);

        //Style 
        const fontSize = letters.two.trim().length === 0 ? (300 - letters.one.length * 15) : 300;
        style.fontSize = `${fontSize}px`;
        setTextStyle(style);


        let sentence = `${letters.one}${letters.two}`;
        if (lastSlot.level === 2) {
            sentence = sentence.toLocaleLowerCase();
        }
        setTextOut(sentence);
        setImageMode(false);
        return color;
    }

    function renderImageMode() {
        const maxLevel = getMaxLevelExcluding([1.5, 7]);
        const imageUrl = `/img/img-${maxLevel}.png`;
        setImageSource(imageUrl);
        setImageMode(true);
    }

    function getMaxLevel() {
        if (stack.length === 0) return 0;
        return Math.max(...stack.map(obj => obj.level));
    }

    function getMaxLevelExcluding(excluded) {
        if (stack.length === 0) return 0;
        const filteredArray = stack.filter(object => !excluded.includes(object.level));
        return Math.max(...filteredArray.map(obj => obj.level));
    }

    function render() {

        // no render reset 
        if (stack.length === 0) {
            renderReset();
            return;
        }

        const maxLevel = getMaxLevel();

        //Find ideas slot
        let foundAutoGen = false;
        for (let indexSlot = 0; indexSlot < stack2.length; indexSlot++) {
            const stackItem = stack2[indexSlot];
            if (stackItem.level === 7) {
                //debugger
                setShowAutoGen(true);
                setAutoGenNumber(stackItem.find.matchResult.one);
                foundAutoGen = true;
                refreshRandomStyles(textStyle.color, stackItem.find.matchResult.one);
                return;
            }
        }
        if (!foundAutoGen) {
            setShowAutoGen(false);
            setAutoGenNumber(30);
        }

        // Draw text mode
        let color = 'black';
        if (maxLevel >= 1 && maxLevel <= 2) {
            color = renderFontStages();
            setImageMode(false);
            return;
        }



        // Draw image 
        if (maxLevel > 2) {
            //debugger
            setImageMode(true);
            renderImageMode();
            return;
        }



    }

    function getLetters(sentence) {
        const firstMatch = ai.slotCharSelection.patterns.wordAndWord(sentence);
        if (firstMatch.success) {
            //debugger
            if (firstMatch.two) {
                if (firstMatch.two.trim().length > 0) {
                    return firstMatch;
                }
            }
        }
        const secondMatch = ai.slotCharSelection.patterns.brandNameIs(sentence);
        if (secondMatch.success) {
            //debugger
            return secondMatch;
        }

        return {
            success: false
        };
    }

    function extractStyling(string) {
        //const string = "draw me 8 and 9, set colour to red, and border to 1px solid grey";
        const regex = /([^\s,]+)\s+to\s+([^,]+)/g;
        const css = {};

        let match;
        while (match = regex.exec(string)) {
            const attribute = match[1];
            const value = match[2];
            css[attribute] = value;
        }

        const style = {};

        for (const property in css) {
            const camelCaseProperty = property.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
            style[camelCaseProperty] = css[property];
        }
        return style;

    }

    function getNextFont(i) {
        const rand = Math.floor(Math.random() * (fonts.length - 1));
        return fonts[rand];
    }

    function refreshRandomStyles(color, number) {
        if (stack.length > 0) {
            if (stack[stack.length - 1].level >= 1) {
                const randoms = createRandomStyles(color, number);
                setRandomStyles(randoms);
            } else {
                setRandomStyles([]);
            }
        } else {
            setRandomStyles([]);
        }
    }

    function createRandomStyles(mainColor, number) {
        const firstSlot = stack[0];
        const letters = getLetters(firstSlot.input);
        let fontSize = 100;
        if (letters.success) {
            fontSize = letters.two.trim().length === 0 ? (100 - letters.one.length * 4) : 100;
        }
        const styleList = [];
        for (let i = 0; i < number; i++) {
            const style = {};
            style.id = i;
            // Generate random values for red, green, and blue
            var red = Math.floor(Math.random() * (256 - 150 + 1)) + 120;
            var green = Math.floor(Math.random() * (256 - 150 + 1)) + 120;
            var blue = Math.floor(Math.random() * (256 - 150 + 1)) + 120;

            // Create a CSS rgb color value
            var bgColor = "rgb(" + red + "," + green + "," + blue + ")";

            var red2 = Math.floor(Math.random() * 180);
            var green2 = Math.floor(Math.random() * 180);
            var blue2 = Math.floor(Math.random() * 180);

            // Create a CSS rgb color value
            var color = "rgb(" + red2 + "," + green2 + "," + blue2 + ")";

            let switchColors = Math.random() < 0.5;

            style.backgroundColor = switchColors ? color : bgColor;

            style.fontFamily = getNextFont(i);
            style.fontSize = fontSize;


            let randomNumber = parseInt(Math.floor(Math.random() * 15));
            let doDark = Math.random() >= 0.5;

            let newColor = doDark ?
                tinycolor(mainColor ? mainColor : textStyle.color).lighten(randomNumber).toString() :
                tinycolor(mainColor ? mainColor : textStyle.color).darken(randomNumber).toString()


            style.color = newColor;

            style.backgroundColor = '#fff';
            style.display = 'inline-block';
            style.textAlign = 'center';

            styleList.push(style);
            // debugger
        }
        return styleList;
    }


    function getContrastingColor(r, g, b) {
        // const rgbValues = color.split(',');
        const avgValue = (r + g + b) / 3;
        if (avgValue > 128) {
            const oppositeRgb = [255 - r, 255 - g, 255 - b];
            if (oppositeRgb[0] >= 128 && oppositeRgb[1] >= 128 && oppositeRgb[2] >= 128) {
                return `rgb(${oppositeRgb[0]}, ${oppositeRgb[1]}, ${oppositeRgb[2]})`;
            } else {
                const minValue = Math.min(...oppositeRgb);
                const valueDiff = 128 - minValue;
                const adjustedRgb = oppositeRgb.map(value => value + valueDiff);
                return `rgb(${adjustedRgb[0]}, ${adjustedRgb[1]}, ${adjustedRgb[2]})`;
            }
        } else {
            const oppositeRgb = [255 - r, 255 - g, 255 - b];
            if (oppositeRgb[0] <= 128 && oppositeRgb[1] <= 128 && oppositeRgb[2] <= 128) {
                return `rgb(${oppositeRgb[0]}, ${oppositeRgb[1]}, ${oppositeRgb[2]})`;
            } else {
                const maxValue = Math.max(...oppositeRgb);
                const valueDiff = maxValue - 128;
                const adjustedRgb = oppositeRgb.map(value => value - valueDiff);
                return `rgb(${adjustedRgb[0]}, ${adjustedRgb[1]}, ${adjustedRgb[2]})`;
            }
        }
    }

}
